import { COLOR, FONT_SIZE } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const AnchorHelpBannerRoot = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  margin: 32px 0px;
  border-radius: 8px;
  border: 1px solid ${COLOR.GRAY200.code};
`;

export const SpanText = styled.span`
  font-size: ${FONT_SIZE.S}px;
  color: ${COLOR.GRAY900.code};
`;
